import Swiper from '../autoload/_swiper';

class TestimonialCarousel {

    doAThing() {
        console.log('animations Do a thing')

    }

    constructor(){

        var swiperClassHome = '.testimonial-swiper';

        $(swiperClassHome).each(function ( index ) {

            var swiperID = 'testimonial-' + index;
            var swiperIDHash = '#testimonial-' + index;

            $(this).attr('id', swiperID);

            var homeSwiper = new Swiper(swiperIDHash, {
                loop: true,
                speed: 500,
                autoplay: {
                    delay: 4500,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable : 'true',
                },
                navigation: {
                    nextEl: '.testimonial-next',
                    prevEl: '.testimonial-prev',
                },
                on: {
                    init() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    },
                },

            });

            homeSwiper.on('transitionStart', function () {

                //console.log('transitionStart');

            });

        });

    }
}

export default TestimonialCarousel



// WEBPACK FOOTER //
// ./scripts/util/testimonialCarousel.js